import { Component } from '@angular/core';

/**
 * Route Folder provides a Router Outlet for a sub Component
 */
@Component({
  selector: 'app-route-folder',
  template: '<router-outlet></router-outlet>',
  styles: ['']
})
export class RouteFolderComponent {

}
